import React, {useEffect} from 'react';
import {Checkbox} from "@mui/material";
import axios from "axios";
import {SYNCHRO_OUT_API_URL} from "../../../constants";

const CustomCheckBox = () => {

    useEffect(() => {
        sendSynchroOutRequest(true);
    }, []);


    function handleChange(checked) {
        if (checked) {
            sendSynchroOutRequest(false);
        } else {
            sendSynchroOutRequest(true);
        }
    }

    function sendSynchroOutRequest(value) {
        const url = `${SYNCHRO_OUT_API_URL}/toggle-freeze?enabled=${value}`;

        axios.post(url)
            .then(response => {
                console.log("Режим изменён:", response.data);
            })
            .catch(error => {
                console.error("Ошибка:", error);
            });
    }

    return (
        <div>
            <Checkbox
                style={{marginBottom: "4px"}}
                color="info"
                onChange={(e) => {
                    handleChange(e.target.checked)
                }}
            /><span>Показать оценки на TV?</span>
        </div>
    );
}

export default CustomCheckBox;